import { DefaultComponentProperty } from '@braskai/utils';

import Image from '@/shared/assets/images/error-page.png';

import { SContainer, SErrorImage, SRefreshPageButton, SText, STitle } from './styled';

export const ErrorContainer = ({ className, style }: DefaultComponentProperty) => {
  const handleRefreshPageClick = () => window.location.reload();

  return (
    <SContainer className={className} style={style}>
      <SErrorImage alt="Error" src={Image} />
      <STitle color="grey.900" variant="title-3-sb">
        Something went wrong
      </STitle>
      <SText color="grey.500" variant="body-1">
        We are already working to fix this.
        <br />
        Please try again later 👉👈
      </SText>
      <SRefreshPageButton size="xl" onClick={handleRefreshPageClick}>
        Refresh page
      </SRefreshPageButton>
    </SContainer>
  );
};
